import React from 'react';
import macbookImage from '../MacBook contents.png';
import DownloadButton from './DownloadButton';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-4">
      
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto animate-fade-in">
        <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold mb-8 animate-float">
          <span
            className="inline-block animate-glow"
            style={{
              color: '#e9d5ff',
              textShadow: '0 0 20px #9333ea, 0 0 40px #9333ea',
              fontFamily: 'Roboto, Helvetica Neue, Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif'
            }}
          >
            FarmMaster
          </span>
          <span className="text-gray-100"> 是一款完全本地化运行的</span>
          <span className="bg-gradient-to-r from-purple-400 via-violet-400 to-purple-300 bg-clip-text text-transparent block mt-2 animate-float" style={{animationDelay: '0.5s'}}>
            项目交互程序
          </span>
        </h1>
        
        <p className="text-xl sm:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed animate-float" style={{animationDelay: '1s'}}>
          支持多个Web3项目的协议交互以及银河任务自动化完成，
          <span className="text-purple-400 font-medium">包括一系列的全自动Web3工具</span>
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-20 animate-float" style={{animationDelay: '1.5s'}}>
          <div className="group relative">
            <DownloadButton variant="hero" />
            <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-violet-500 rounded-lg blur-lg opacity-0 group-hover:opacity-30 transition-opacity duration-300 pointer-events-none"></div>
          </div>
          <a 
            href="https://farmmaster.gitbook.io/farmmaster-shi-yong-wen-dang" 
            target="_blank" 
            rel="noopener noreferrer"
            className="relative border border-purple-600/30 text-gray-300 hover:text-white hover:border-purple-500/50 px-8 py-4 rounded-lg text-lg font-medium transition-all duration-300 hover:scale-105 backdrop-blur-sm bg-purple-900/10 hover:bg-purple-800/20 inline-flex items-center space-x-2"
          >
            <span>查看使用文档</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
        
        {/* MacBook Preview */}
        <div className="mt-16 relative flex justify-center">
          <div className="relative" style={{ width: '75vw', maxWidth: '1400px' }}>
            {/* MacBook Image Container - Static, no animations */}
            <div className="relative flex justify-center">
              <div className="relative">
                
                {/* MacBook Image - Transparent background, 75% of viewport width */}
                <img 
                  src={macbookImage} 
                  alt="MacBook Dashboard Preview" 
                  className="w-full h-auto"
                  style={{
                    filter: 'brightness(1.0) contrast(1.02) saturate(1.05)',
                  }}
                />
                
                {/* Subtle ambient glow to help integration */}
                <div className="absolute inset-0 -z-10">
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4/5 h-3/5 bg-gradient-radial from-blue-500/3 via-cyan-500/2 to-transparent blur-3xl"></div>
                </div>
                
                {/* Very subtle drop shadow for depth */}
                <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 w-3/4 h-12 bg-black/8 blur-2xl rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;